import { useNavigate } from "react-router-dom"
import DynamicButton from "../../../components/common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import DynamicDatatable from "../../../components/common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import LightGrayBgWrapper from "../../../components/common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"
import ColoredText from "../../../components/common/AdminCommonComponents/ColoredText/ColoredText"
import BlueBadge from "../../../components/common/AdminCommonComponents/BlueBadge/BlueBadge"

const ShippingAndDelivery = () => {

  const navigate = useNavigate()

  const tableData = [
    { ID: "S0001", deliveryType: "Economy", estimatedDeliveryTime: "5-7 Business Days", defaultRate: "$1.00", status: "Active" },
    { ID: "S0001", deliveryType: "Economy", estimatedDeliveryTime: "5-7 Business Days", defaultRate: "$1.00", status: "Active" },
    { ID: "S0001", deliveryType: "Economy", estimatedDeliveryTime: "5-7 Business Days", defaultRate: "$1.00", status: "Active" },
    { ID: "S0001", deliveryType: "Economy", estimatedDeliveryTime: "5-7 Business Days", defaultRate: "$1.00", status: "Active" },
  ]

  const columns = [
    {
      name: "ID",
      selector: (row) => row.ID,
      grow: 0.3,
    },
    {
      name: "Delivery Type",
      selector: (row) => row.deliveryType,
    },
    {
      name: "Estimated Delivery Time",
      selector: (row) => row.estimatedDeliveryTime,
    },
    {
      name: "Default Rate",
      selector: (row) => row.defaultRate,
      cell: (row) => <BlueBadge theme="light-green" textBlack>{row.defaultRate}</BlueBadge>,
      center: 'true'
    },
    {
      name: "Status",
      selector: (row) => row.status,
      cell: (row) => {
        let lowerCaseStatus = row.status.toLowerCase()
        const colors = {
          active: '#41B8E4',
          inactive: '#EC7426'
        }

        return <ColoredText color={colors[lowerCaseStatus]}>{row.status}</ColoredText>
      }
    },
    {
      name: "Actions",
      cell: () => (
        <div className="d-flex gap-2 align-items-center">
          <button style={{ all: "unset" }}>Edit</button>
          <button style={{ all: "unset" }}>Delete</button>
        </div>
      ),
    },
  ]

  return (
    <LightGrayBgWrapper>

      <div className="fw-semibold fs-5 mb-3">Shipping Options</div>

      <div className="p-3 d-flex align-items-center justify-content-between bg-white shadow">
        <div className="fw-semibold fs-5">Delivery types</div>
        <DynamicButton theme="blue" onClick={() => navigate('/shipping-and-delivery/shipping-options/add-new-shipping-option')}>
          Add new
        </DynamicButton>
      </div>

      <DynamicDatatable columns={columns} data={tableData} type="yellow" />
    </LightGrayBgWrapper>
  )
}

export default ShippingAndDelivery
